var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNoteIcon = function SvgNoteIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_5977_15507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1029 13.8931C9.70293 13.9931 9.50293 14.3931 9.50293 14.7931C9.50293 15.2931 9.90293 15.7931 10.5029 15.7931C11.1029 15.7931 11.5029 15.3931 11.5029 14.7931C11.5029 13.9931 10.7029 13.5931 10.1029 13.8931Z",
    fill: "#2555EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5029 5.79297C9.90293 5.79297 9.50293 6.19297 9.50293 6.79297V11.793C9.50293 12.393 9.90293 12.793 10.5029 12.793C11.1029 12.793 11.5029 12.393 11.5029 11.793V6.79297C11.5029 6.19297 11.1029 5.79297 10.5029 5.79297Z",
    fill: "#2555EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5029 0.792969C5.00293 0.792969 0.50293 5.29297 0.50293 10.793C0.50293 16.293 5.00293 20.793 10.5029 20.793C16.0029 20.793 20.5029 16.293 20.5029 10.793C20.5029 5.29297 16.0029 0.792969 10.5029 0.792969ZM10.5029 18.793C6.10293 18.793 2.50293 15.193 2.50293 10.793C2.50293 6.39297 6.10293 2.79297 10.5029 2.79297C14.9029 2.79297 18.5029 6.39297 18.5029 10.793C18.5029 15.193 14.9029 18.793 10.5029 18.793Z",
    fill: "#2555EF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5977_15507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.50293 0.792969)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NoteIcon.8c36539f.svg";
export { ForwardRef as ReactComponent };